import { Button } from 'components/common'
import { LogoutIcon } from 'components/icons'
import { useAuth, usePageAccess } from 'hooks'
import { PAGE_STORE_ORDERS } from 'utils/constants'

const UserName = () => {
  const { user, logout } = useAuth()
  const { page } = usePageAccess()

  if (!user) {
    return <></>
  }

  const name = `${user?.firstName} ${user?.lastName}`
  const logoText = `${user?.firstName?.[0]}${user?.lastName?.[0]}`.toUpperCase()

  return (
    <div className="group relative flex items-center justify-center gap-2">
      <div className="flex items-center gap-x-2 rounded-md border-2 px-2 py-1 max-sm:border-none">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-sidebar-primary text-sm font-bold leading-tight tracking-wider text-white">
          {logoText}
        </div>
        <div className="hidden font-bold capitalize sm:block">{name}</div>
      </div>
      {page === PAGE_STORE_ORDERS.id && (
        <Button
          className="m-2 bg-sidebar-primary"
          buttonText="Logout"
          textClassName="max-sm:hidden block"
          onClick={logout}
          icon={<LogoutIcon />}
        />
      )}
    </div>
  )
}

export default UserName
